"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeywordByKey = void 0;
var getKeywordByKey = function (key) {
    var _a, _b;
    var keywords = (_b = (_a = window === null || window === void 0 ? void 0 : window.adServer) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.keywords;
    if (keywords) {
        return keywords[key];
    }
    return undefined;
};
exports.getKeywordByKey = getKeywordByKey;
